export default (propertyName, className = '') => {
    if (window.IS_IN_EDIT_MODE && propertyName) {
        return {
            className: (className ? className + ' ' : '') + " dev-safety-class" + ' epi-editContainer',
            'data-epi-property-name': propertyName,
            'data-epi-use-mvc': 'True',
        };
    }
    else {
        return { className: (className ? className + ' ' : '') + " dev-safety-class" };
    }
};
